import { useLocation } from 'wouter';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import type { ProjectCardProps } from '@shared/widget-schemas';
import { capitalizeFirst } from './textFormat';

export function ProjectCard({
  shortId,
  name,
  type,
  status,
  decisionIntent,
  progressSummary,
}: ProjectCardProps) {
  const [, setLocation] = useLocation();

  return (
    <button
      type="button"
      onClick={() => setLocation(`/projects/${shortId}/overview`)}
      className="block w-full text-left"
      data-testid="project-card"
      aria-label={`Open project ${name}`}
    >
      <Card className="w-full hover:bg-muted/40 transition">
        <CardHeader className="pb-2">
          <CardTitle className="text-base">{capitalizeFirst(name)}</CardTitle>
          {(type || status) && (
            <div className="flex gap-2 text-xs text-muted-foreground">
              {type && <span>{type}</span>}
              {status && (
                <span>
                  <span className="sr-only">Status: </span>
                  <span aria-hidden="true">• </span>
                  {status}
                </span>
              )}
            </div>
          )}
        </CardHeader>
        {(decisionIntent || progressSummary) && (
          <CardContent className="text-sm space-y-1">
            {decisionIntent && <p className="text-muted-foreground">{capitalizeFirst(decisionIntent)}</p>}
            {progressSummary && <p className="text-xs">{capitalizeFirst(progressSummary)}</p>}
          </CardContent>
        )}
      </Card>
    </button>
  );
}
